import React from 'react';
import { connect } from 'react-redux';
import properties from '../../../constants/Properties';
import menuType from '../../../constants/MenuType';
import { hideMenus, showRecorder } from '../../../actions/MenuActions';
import audioRecorder from '../../utils/AudioRecorder';
import locales from '../../../locales/LocalesManager';
import appParameters from '../../../components/utils/AppParameters';
import storeManager from '../../../store/StoreManager';
import saveManager from '../../utils/SaveManager';
import platformDetection from '../../../components/utils/PlatformDetection';
import mouseUtils from '../../../components/utils/MouseUtils';
import apiServiceUtils from '../../../components/utils/ApiServiceUtils';
import reactNativeBridge from '../../utils/ReactNativeBridge';
import playController from '../../utils/PlayController';
import audioEditorUtils from '../../audioEditor/utils/AudioEditorUtils';
import hoverManager from '../../utils/HoverManager';
import { redoAction, undoAction } from '../../utils/KeyboardShortcuts';
import { deleteItem, setMarkerPosition } from '../../../actions/AudioEditorActions';
import audioToolUtils from '../utils/AudioToolUtils';

const AudioToolHeaderContent = React.createClass({
    getInitialState() {
        return {
            isPlayButtonOver: false,
            isStartButtonOver: false,
            isEndButtonOver: false,
            isRecordButtonOver: false,
            isUndoOver: false,
            isRedoOver: false,
            isDeleteOver: false,
            isPlaying: false
        };
    },
    componentDidMount() {
        playController.updateRecordingMenuButtons = this.updateViewProperties;
        playController.executePlayPause = this.executePlayPause;
        playController.executeStop = this.executeStop;
    },
    componentWillUnmount() {
        playController.updateRecordingMenuButtons = undefined;
        playController.executePlayPause = undefined;
        playController.executeStop = undefined;
    },
    onPlayButtonMouseIn () {
        hoverManager.show(this.refs.play, 'playCartoon');

        this.setState({
            isPlayButtonOver: true
        });
    },
    onPlayButtonMouseOut () {
        hoverManager.hide();

        this.setState({
            isPlayButtonOver: false
        });
    },
    onStartButtonMouseIn () {
        hoverManager.show(this.refs.start, 'startAudio');

        this.setState({
            isStartButtonOver: true
        });
    },
    onStartButtonMouseOut() {
        hoverManager.hide();

        this.setState({
            isStartButtonOver: false
        });
    },
    onEndButtonMouseIn () {
        hoverManager.show(this.refs.end, 'endAudio');

        this.setState({
            isEndButtonOver: true
        });
    },
    onEndButtonMouseOut() {
        hoverManager.hide();

        this.setState({
            isEndButtonOver: false
        });
    },
    onRecordButtonMouseIn() {
        hoverManager.show(this.refs.recordingHolder, locales.getCaption('RecordSoundAlert', 'record'), 'top', true);

        this.setState({
            isRecordButtonOver: true
        });
    },
    onRecordButtonMouseOut() {
        hoverManager.hide();

        this.setState({
            isRecordButtonOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.props.dispatch(hideMenus([menuType.ALL_MENUS]));
    },
    onRecordDown(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (playController.isPlaying || this.props.refreshAudioElements)
            return;

        if (platformDetection.isIOSApp()) {
            if (!reactNativeBridge.isIOSRecorderEnabled)
                reactNativeBridge.init(this.initRecording);
            else
                this.props.dispatch(showRecorder(true));
        } else {
            if (!audioRecorder.isRecordAvailable)
                audioRecorder.init(this.initRecording);
            else
                this.props.dispatch(showRecorder(true));
        }
    },
    initRecording() {
        if (platformDetection.isIOSApp())
            reactNativeBridge.isIOSRecorderEnabled = true;

        this.props.dispatch(showRecorder(true));
    },
    executeStop() {
        this.setState({
            isPlaying: false
        });

        playController.stop();
    },
    onStart(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

            this.setState({
                isPlaying: false
            });

            playController.stop();
            var position = 0;
            this.props.dispatch(setMarkerPosition(position));
            playController.checkScrollPosition(position, true);
    },
    onEnd(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.setState({
            isPlaying: false
        });

        playController.stop();
        var position = audioEditorUtils.getTimelinesMaxPosition();
        this.props.dispatch(setMarkerPosition(position));
        playController.checkScrollPosition(position);
    },
    onPlay(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.doNewPlay();
    },
    executePlayPause() {
        this.doNewPlay();
    },
    doNewPlay() {
        if (this.state.isPlaying)
            playController.pause();
        else
            playController.play();

        this.togglePlayState();
    },
    togglePlayState() {
        if (!this.state.isPlaying) {
            this.setState({
                isPlaying: true
            });
        } else {
            this.setState({
                isPlaying: false
            });
        }
    },
    updateViewProperties() {
        this.setState({
            isPlaying: false
        });

        this.forceUpdate();
    },
    onUndoMouseIn() {
        hoverManager.show(this.refs.undo, 'undo');

        this.setState({
            isUndoOver: true
        });
    },
    onUndoMouseOut() {
        hoverManager.hide();

        this.setState({
            isUndoOver: false
        });
    },
    onRedoMouseIn() {
        hoverManager.show(this.refs.redo, 'redo');

        this.setState({
            isRedoOver: true
        });
    },
    onRedoMouseOut() {
        hoverManager.hide();

        this.setState({
            isRedoOver: false
        });
    },
    onUndo(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (playController.isPlaying)
            return;

        undoAction(this.props.dispatch);
        saveManager.isContentChanged(true);
    },
    onRedo(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (playController.isPlaying)
            return;

        redoAction(this.props.dispatch);
        saveManager.isContentChanged(true);
    },
    isUndoAvailable() {
        const undo = this.props.undo;

        if (undo && undo.length > 0)
            return true;
        else
            return false;
    },
    isRedoAvailable() {
        const redo = this.props.redo;

        if (redo && redo.length > 0)
            return true;
        else
            return false;
    },
    onDeleteMouseIn () {
        hoverManager.show(this.refs.delete, 'deleteAudioItem');

        this.setState({
            isDeleteOver: true
        });
    },
    onDeleteMouseOut() {
        hoverManager.hide();

        this.setState({
            isDeleteOver: false
        });
    },
    onDelete(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.props.dispatch(deleteItem());
        saveManager.isContentChanged(true);
        audioEditorUtils.checkTimelineWidth();
        audioEditorUtils.addActionToHistory();
    },
    getCurrentTime() {
        return audioToolUtils.getCurrentTime(this.props.markerPosition);
    },
    render() {
        const width = this.props.width;
        const height = audioToolUtils.headerHeight();
        var topPosition = 45;
        var buttonsHolderWidth = properties.BUTTONS_HOLDER_WIDTH;
        var topBarHeight = 0;

        if (platformDetection.isIOSApp()) {
            topBarHeight = properties.CLIPART_BUTTON_HEIGHT_OLD;
            topPosition = 35;
        }

        topBarHeight = topBarHeight + apiServiceUtils.getNoInternetConnectionAlertHeight();

        var menuStyle = {
            position: 'absolute',
            backgroundColor: properties.RECORDING_MENU_BACKGROUND,
            width: width,
            height: height,
            top: topBarHeight,
            left: 0,
            cursor: 'default',
            userSelect: 'none',
            userDrag: 'none',
            WebkitUserSelect: 'none'
        };

        var durationStyle = {
            position: 'absolute',
            backgroundColor: 'white',
            width: buttonsHolderWidth - 2 * 30,
            height: properties.RECORDING_BUTTON_HEIGHT + 2 + 14,
            top: topPosition - 7,
            left: 20,
            cursor: 'default',
            userSelect: 'none',
            userDrag: 'none',
            WebkitUserSelect: 'none'
        };

        const spanStyle = {
            position: 'absolute',
            top: 6,
            left: 0,
            color: 'black',
            fontSize: 26,
            fontWeight: 'bold',
            width: durationStyle.width,
            height: durationStyle.height,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            textAlign: 'center'
        };

        // START button
        var borderColor = 'white';
        var iconColor;

        if (this.state.isStartButtonOver == true) {
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        } else {
            iconColor = 'black';
        }

        const startStyle = {
            width: properties.RECORDING_PLAY_BUTTON_WIDTH,
            height: properties.RECORDING_BUTTON_HEIGHT,
            background: 'white',
            position: 'absolute',
            left: buttonsHolderWidth,
            top: topPosition,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: 3,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const startIcon = 'fa fa-step-backward fa-1x';
        const startIconStyle = {
            position: 'absolute',
            top: 6,
            left: 21,
            color: iconColor
        };

        // PLAY button
        borderColor = 'white';

        if (this.state.isPlayButtonOver == true) {
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        } else {
            iconColor = 'black';
        }

        var playStyle = {
            width: properties.RECORDING_PLAY_BUTTON_WIDTH,
            height: properties.RECORDING_BUTTON_HEIGHT,
            background: 'white',
            position: 'absolute',
            left: buttonsHolderWidth + properties.RECORDING_GAP + properties.RECORDING_PLAY_BUTTON_WIDTH,
            top: topPosition,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: 3,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        var playIcon = 'fa fa-play';
        var playIconPosition = 24;

        if (this.state.isPlaying) {
            playIcon = 'fa fa-pause';
            playIconPosition = 22;
        }

        var playIconStyle = {
            position: 'absolute',
            top: 6,
            left: playIconPosition,
            color: iconColor
        };

        var playTabIndex;

        if (audioEditorUtils.getTimelinesMaxPosition() == 0 || this.props.refreshAudioElements) { // is Disabled
            playStyle.borderColor = 'white';
            playStyle.opacity = 0.5;
            playIconStyle.color = 'black';
            playIconStyle.left = 24;
            playIcon = 'fa fa-play';
            playTabIndex = '-1';
        }

        // END button
        borderColor = 'white';

        if (this.state.isEndButtonOver == true) {
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        } else {
            iconColor = 'black';
        }

        const endStyle = {
            width: properties.RECORDING_PLAY_BUTTON_WIDTH,
            height: properties.RECORDING_BUTTON_HEIGHT,
            background: 'white',
            position: 'absolute',
            left: buttonsHolderWidth + properties.RECORDING_GAP * 2 + properties.RECORDING_PLAY_BUTTON_WIDTH * 2,
            top: topPosition,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: 3,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const endIcon = 'fa fa-step-forward';
        const endIconStyle = {
            position: 'absolute',
            top: 6,
            left: 21,
            color: iconColor
        };

        // undo style
        var opacity = 1;
        var tabIndexUndo;

        if (this.isUndoAvailable() == false) {
            iconColor = 'black';
            borderColor = 'white';
            opacity = 0.6;
            tabIndexUndo = '-1';
        } else {
            if (this.state.isUndoOver == true) {
                iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
                borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            }
            else {
                iconColor = 'black';
                borderColor = 'white';
            }
        }

        const undoStyle = {
            width: properties.RECORDING_BUTTON_HEIGHT,
            height: properties.RECORDING_BUTTON_HEIGHT,
            background: 'white',
            position: 'absolute',
            left: endStyle.left + endStyle.width + 50,
            top: topPosition,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: 50,
            opacity: opacity,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const undoIconStyle = {
            position: 'absolute',
            top: 6,
            left: 8,
            color: iconColor
        };

        // redo style
        var tabIndexRedo;

        if (this.isRedoAvailable() == false) {
            iconColor = 'black';
            borderColor = 'white';
            opacity = 0.6;
            tabIndexRedo = '-1';
        } else {
            opacity = 1;

            if (this.state.isRedoOver == true) {
                iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
                borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            }
            else {
                iconColor = 'black';
                borderColor = 'white';
            }
        }

        const redoStyle = {
            width: properties.RECORDING_BUTTON_HEIGHT,
            height: properties.RECORDING_BUTTON_HEIGHT,
            background: 'white',
            position: 'absolute',
            left: undoStyle.left + properties.RECORDING_GAP + undoStyle.width,
            top: topPosition,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: 50,
            opacity: opacity,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const redoIconStyle = {
            position: 'absolute',
            top: 6,
            left: 8,
            color: iconColor
        };

        // Delete audio
        var isAudioSelected = audioEditorUtils.isAudioSelected();
        var opacity = 1.0;
        var deleteSrc = appParameters.RESOURCES_LOCATION() + 'assets/trash.svg';
        var tabIndexDelete;

        if (!isAudioSelected) {
            opacity = 0.6;
            tabIndexDelete = '-1';
        } else {
            if (this.state.isDeleteOver == true)
                deleteSrc = appParameters.RESOURCES_LOCATION() + 'assets/trash_hover.svg';
        }

        const deleteSoundButtonStyle = {
            width: properties.RECORDING_BUTTON_HEIGHT,
            height: properties.RECORDING_BUTTON_HEIGHT,
            background: properties.ADD_MUSIC_BUTTON_BACKGROUND,
            position: 'absolute',
            left: redoStyle.left + redoStyle.width + 30,
            top: topPosition,
            borderColor: 'white',
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: 50,
            opacity,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        var deleteIconStyle = {
            position: 'absolute',
            top: 0,
            left: 0
        };

        // RECORD Button
        const recordButtonSize = properties.RECORDING_BUTTON_HEIGHT;
        var recordIcon;

        if (this.state.isRecordButtonOver == true)
            recordIcon = 'assets/recordHover.png';
        else
            recordIcon = 'assets/record.png';

        borderColor = 'red';

        var leftPos = buttonsHolderWidth + (this.props.width - buttonsHolderWidth) / 2 - recordButtonSize / 2;
        var recordMinPosition = deleteSoundButtonStyle.left + deleteSoundButtonStyle.width + 30;

        if (leftPos < recordMinPosition)
            leftPos = recordMinPosition;

        var recordStyle = {
            width: recordButtonSize,
            height: recordButtonSize,
            position: 'absolute',
            left: leftPos,
            top: topPosition,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'transparent',
            borderStyle: 'hidden',
            borderWidth: 2,
            borderRadius: 50
        };

        const recordIconStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: recordButtonSize,
            height: recordButtonSize
        };

        var recordingHolderStyle = {};

        if (platformDetection.isIOS())
            recordStyle.left = deleteSoundButtonStyle.left + deleteSoundButtonStyle.width + 75;

        return (
            <div id='recordingMenu' style={menuStyle} onMouseDown={this.onClick} onTouchEnd={this.onClick}>
                <div style={durationStyle}>
                    <span style={spanStyle}>{this.getCurrentTime()}</span>
                </div>

                <button ref='start' style={startStyle} aria-label={locales.getCaption('startAudio', 'hover')} onMouseOver={this.onStartButtonMouseIn} onMouseOut={this.onStartButtonMouseOut} onClick={this.onStart} onTouchEnd={this.onStart}>
                    <i style={startIconStyle} className={startIcon}></i>
                </button>
                <button ref='play' style={playStyle} aria-label={locales.getCaption('playCartoon', 'hover')} tabIndex={playTabIndex} aria-disabled={playTabIndex == '-1' ? true : false} onMouseOver={this.onPlayButtonMouseIn} onMouseOut={this.onPlayButtonMouseOut} onClick={this.onPlay} onTouchEnd={this.onPlay}>
                    <i style={playIconStyle} className={playIcon}></i>
                </button>
                <button ref='end' style={endStyle} aria-label={locales.getCaption('endAudio', 'hover')} onMouseOver={this.onEndButtonMouseIn} onMouseOut={this.onEndButtonMouseOut} onClick={this.onEnd} onTouchEnd={this.onEnd}>
                    <i style={endIconStyle} className={endIcon}></i>
                </button>

                <button ref="undo" style={undoStyle} tabIndex={tabIndexUndo} aria-disabled={tabIndexUndo == '-1' ? true : false} aria-label={locales.getCaption('undo', 'hover')} onTouchEnd={this.onUndo} onClick={this.onUndo} onMouseOver={this.onUndoMouseIn} onMouseOut={this.onUndoMouseOut}>
                    <i style={undoIconStyle} className="fa fa-undo"></i>
                </button>
                <button ref="redo" style={redoStyle} tabIndex={tabIndexRedo} aria-disabled={tabIndexRedo == '-1' ? true : false} aria-label={locales.getCaption('redo', 'hover')} onTouchEnd={this.onRedo} onClick={this.onRedo} onMouseOver={this.onRedoMouseIn} onMouseOut={this.onRedoMouseOut}>
                    <i style={redoIconStyle} className="fa fa-repeat"></i>
                </button>

                <button ref='delete' style={deleteSoundButtonStyle} tabIndex={tabIndexDelete} aria-disabled={tabIndexDelete == '-1' ? true : false} aria-label={locales.getCaption('deleteAudioItem', 'hover')} onMouseOver={this.onDeleteMouseIn} onMouseOut={this.onDeleteMouseOut} onTouchEnd={this.onDelete} onClick={this.onDelete}>
                    <img alt={locales.getCaption('deleteAudioItem', 'hover')} aria-hidden='true' style={deleteIconStyle} src={deleteSrc}/>
                </button>

                <div style={recordingHolderStyle}>
                    <button ref='recordingHolder' style={recordStyle} aria-label={locales.getCaption('RecordSoundAlert', 'record')} onMouseOver={this.onRecordButtonMouseIn} onMouseOut={this.onRecordButtonMouseOut} onClick={this.onRecordDown} onTouchStart={this.onRecordDown}>
                        <img alt={locales.getCaption('RecordSoundAlert', 'record')} aria-hidden='true' style={recordIconStyle} src={appParameters.RESOURCES_LOCATION() + recordIcon}/>
                    </button>
                </div>

                <audio id='audioBrowserSound' className='audioItem' preload='auto' playsInline/>
                <audio ref='recordedAudio' className='audioItem' preload='auto' playsInline/>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const undo = state.undoRedo.undo;
    const redo = state.undoRedo.redo;
    const timelines = state.audioEditor.timelines;
    const markerPosition = state.audioEditor.markerPosition;
    var refreshAudioElements = state.audioEditor.refreshAudioElements;

    if (refreshAudioElements == undefined)
        refreshAudioElements = false;

    return {
        undo,
        redo,
        timelines,
        markerPosition,
        refreshAudioElements
    };
}

export const AudioToolHeader = connect(mapStateToProps)(AudioToolHeaderContent);



/** WEBPACK FOOTER **
 ** ./src/components/audioTool/menus/AudioToolHeader.js
 **/